import React, { useEffect, useState } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';

import './UserManagement.css';
import CreateUsers from './CreateUsers/CreateUsers';
import ListUsers from './ListUsers/ListUsers';
import Notification from '../Notification/Notification';

function UserManagement() {
  const location = useLocation();
  const [notification, setNotification] = useState({ message: '', type: '' });

  useEffect(() => {
    if (location.state && location.state.message) {
      setNotification({
        message: location.state.message,
        type: location.state.type,
      });
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div>
      <h1>User Management</h1>
      <Routes>
        <Route path="/" element={<Navigate to="list" />} />
        <Route path="list" element={<ListUsers />} />
        <Route path="create" element={<CreateUsers />} />
      </Routes>
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
}

export default UserManagement;
